var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNewWeeklyplan(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "layout-window-6 2",
    clipPath: "url(#clip0_3092_5520)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 8V16H8H16V8V0H8H0V8ZM1.19431 2.4455V3.69668H8H14.8057V2.4455V1.19431H8H1.19431V2.4455ZM1.19431 9.84834V14.8057H3.00474H4.81517V9.84834V4.891H3.00474H1.19431V9.84834ZM6.00948 9.84834V14.8057H8H9.99052V9.84834V4.891H8H6.00948V9.84834ZM11.1848 9.84834V14.8057H12.9953H14.8057V9.84834V4.891H12.9953H11.1848V9.84834Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3092_5520"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewWeeklyplan);
export default __webpack_public_path__ + "static/media/new_weeklyplan.507f9997a1d25e96ea20d540cf74cef5.svg";
export { ForwardRef as ReactComponent };